const LOGIN_REQUEST = 'openblock-gui/auth/LOGIN_REQUEST';
const LOGIN_SUCCESS = 'openblock-gui/auth/LOGIN_SUCCESS';
const LOGIN_FAILURE = 'openblock-gui/auth/LOGIN_FAILURE';
const LOGOUT = 'openblock-gui/auth/LOGOUT';
const SESSION_CHECK_START = 'openblock-gui/auth/SESSION_CHECK_START';
const SESSION_CHECK_END = 'openblock-gui/auth/SESSION_CHECK_END';

// The GUI starts in `checkingSession`: while the session cookie is being
// verified the menu bar must not flash the anonymous "Log In" button for a
// user who is in fact already signed in.
const anonymousState = {
    status: 'anonymous',
    user: null,
    error: null
};

const initialState = {
    status: 'checkingSession',
    user: null,
    error: null
};

const reducer = function (state = initialState, action) {
    switch (action.type) {
    case SESSION_CHECK_START:
        return Object.assign({}, state, {
            status: 'checkingSession',
            error: null
        });
    case SESSION_CHECK_END:
        return anonymousState;
    case LOGIN_REQUEST:
        return Object.assign({}, state, {
            status: 'authenticating',
            error: null
        });
    case LOGIN_SUCCESS:
        return {
            status: 'authenticated',
            user: action.user,
            error: null
        };
    case LOGIN_FAILURE:
        return Object.assign({}, state, {
            status: 'error',
            user: null,
            error: action.error
        });
    case LOGOUT:
        return anonymousState;
    default:
        return state;
    }
};

const sessionCheckStart = function () {
    return {type: SESSION_CHECK_START};
};

const sessionCheckEnd = function () {
    return {type: SESSION_CHECK_END};
};

const loginRequest = function () {
    return {type: LOGIN_REQUEST};
};

const loginSuccess = function (user) {
    return {type: LOGIN_SUCCESS, user: user};
};

const loginFailure = function (error) {
    return {type: LOGIN_FAILURE, error: error};
};

const logout = function () {
    return {type: LOGOUT};
};

const getIsLoggedIn = function (auth) {
    return auth.status === 'authenticated';
};

const getIsCheckingSession = function (auth) {
    return auth.status === 'checkingSession';
};

export {
    reducer as default,
    initialState as authInitialState,
    sessionCheckStart,
    sessionCheckEnd,
    loginRequest,
    loginSuccess,
    loginFailure,
    logout,
    getIsLoggedIn,
    getIsCheckingSession
};
